import React from 'react';

import { CircularProgress } from '@mui/material';
import clsx from 'clsx';

import useMobileCheck from 'hooks/useMobileCheck';

import styles from './Loader.module.scss';

export interface CircularProgressProps {
  size?: number;
  customContainerClassname?: string;
  customLoaderClassname?: string;
  containerWithoutMargin?: boolean;
  message?: string;
}

const Loader = ({
  size,
  customContainerClassname,
  customLoaderClassname,
  containerWithoutMargin,
  message,
}: CircularProgressProps) => {
  const isMobile = useMobileCheck();
  const defaultSize = isMobile ? 50 : 95;

  return (
    <div
      className={clsx(styles.loaderContainer, containerWithoutMargin && styles.withoutMargin, customContainerClassname)}
    >
      <CircularProgress
        size={size || defaultSize}
        classes={{ colorPrimary: clsx(styles.colorPrimary, customLoaderClassname) }}
        thickness={2.5}
      />
      {message && (
        <div className={styles.messageWrapper}>
          <div className={styles.message}>
            {message}
            <div className={styles.snippet}>
              <div className={styles.stage}>
                <div className={styles.dotElastic}></div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Loader;
